// Analytics store helper functions and data
import { StoreInitialValues } from "@multicines/stores";

import { AnalyticsStoreValues } from "./analytics.store.types";

export const defaultValues: StoreInitialValues<AnalyticsStoreValues> = {
  analyticsInitialized: false
};
